import script from "./BuilderModalClose.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderModalClose.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderModalClose.vue?vue&type=style&index=0&id=783d97ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-783d97ad"]])

export default __exports__